import axios from "axios";
import Vue from 'vue'
import store from '../index.js.erb'
import _ from "lodash";
import InteractionHostelOrdersServices from '../../../components/application/statement_hostel/Services/Api/Commission/InteractionHostelOrders'
import CommissionInteractionStatementsServices
    from "../../../components/application/statement_hostel/Services/Api/Commission/InteractionStatements";

const HostelOrdersStore = {
    namespaced: true,
    state: {
        hostel_orders: [],
        status_cr_order: {},
        distribution_persons_records: [],
        status_distr_pers_records: true
    },
    getters: {
    },
    mutations: {
        setHostelOrders(state, hostel_orders){
            state.hostel_orders = hostel_orders
        },
        setStatusCrOrder(state, status_cr_order){
            state.status_cr_order = status_cr_order
        },
        setDistributionPersonsRecords(state, distribution_persons_records){
            state.distribution_persons_records = distribution_persons_records
        },
        setStatusDistrPersRecords(state, status_distr_pers_records){
            state.status_distr_pers_records = status_distr_pers_records
        }
    },
    actions: {
        async CreateOrder({state, commit, dispatch}, distributions_records){
            const response = await InteractionHostelOrdersServices.create(distributions_records)

            commit('setStatusCrOrder', response.data)
        },
        async IndexOrder({state, commit, dispatch}, department_id){
            const response = await InteractionHostelOrdersServices.index({department_id: department_id})
            commit('setHostelOrders', response.data.orders)
        },
        async GetDistributionPersonsRecords({state, commit, dispatch}, department_id){
            commit('setStatusDistrPersRecords', true)
            const response = await InteractionHostelOrdersServices.get_distribution_persons_records({department_id: department_id})

            if (response.status === 200){
                commit('setStatusDistrPersRecords', false)
                commit('setDistributionPersonsRecords', response.data.distribution_person_for_departments)
            }
        }
    }
}

export default HostelOrdersStore